var module = angular.module('octopusApp.infrastructure');

module.directive('ngBindHtmlTemplate', function($compile, octopusClient) {
  return {
    link: function($scope, $element, $attrs) {
      var html = $scope.$eval($attrs.ngBindHtmlTemplate);
      $element.html(html);
      $compile($element.contents())($scope);
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/ng_bind_html_template.js
// module id = 670
// module chunks = 1